// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createAdminPriceList = (client) => ({
    /**
     * `GET /admin/price-lists/:id/products`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminPriceListsIdProductsRetrieve
     * @source apps/backend/src/api/admin/price-lists/[id]/products/route.ts
     */
    listProducts: (id, query, headers) => client.fetch(buildPath("/admin/price-lists/:id/products", [id]), { method: "GET", query, headers }),
});
//# sourceMappingURL=price-lists.js.map